import { useMemo } from 'react';
import DocumentShow from 'components/UploadedFiles/DocumentShow';
import { Modal } from 'reactstrap';
import * as Utilities from 'utilities/utils';

export interface DocumentPreviewModalProps {
  showModal: boolean;
  closeModal: () => void;
  id: number | null;
  /**
   * Old ugly dependency to refresh the list in parent component
   */
  component: any;
}

export const DocumentPreviewModal = ({
  showModal,
  closeModal,
  id,
  component,
}: DocumentPreviewModalProps) => {
  const uploadFileYear = useMemo(
    () => Utilities.getStorageData()?.pref_type_options?.upload_file_year || [],
    [],
  );
  const uploadFileMonth = useMemo(
    () =>
      Utilities.getStorageData()?.pref_type_options?.upload_file_month || [],
    [],
  );

  return (
    <Modal isOpen={showModal} className="Md-full-width modal-FullH">
      <DocumentShow
        selectedItem={{ id }}
        onButtonClose={closeModal}
        years={uploadFileYear}
        months={uploadFileMonth}
        component={component}
      />
    </Modal>
  );
};
